<template>
    <div class="page-wrapper" id="scroll_top">
        <section class="poste_details" v-if="pageIsLoaded">
            <div class="title_wrap">
                <div class="left">
                    <!-- <h2 class="title small">{{ $t('Politique de confidentialité') }}</h2> -->
                    <h1 class="title medium"><span v-html="content.title"></span></h1>
                </div>
            </div>
        </section>

        <section class="txt_row small-padding-bottom wysiwyg" id="next" v-if="pageIsLoaded">
            <div class="row">
                <p class="regular-text">
                    <span v-html="content.descriptionHtml"></span>
                </p>
            </div>
        </section>
    </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'

// import GLightbox from 'glightbox'
// import Flickity from 'flickity'

export default {
    data() {
        return {
            isSending: false,
            formMessage: '',
            formMessageStatus: '',
            fileName: '',
            formData: {
                nom: '',
                prenom: '',
                telephone: '',
                courriel: '',
                source: '',
                message: ''
            },
        }
    },

    watch: {
        pageIsLoaded: {
            handler(pageIsLoaded) {
                if (pageIsLoaded) {
                    // Page loaded with Data
                    setTimeout(() => {
                        // this.lightboxelement = GLightbox
                        // GLightbox()

                        setTimeout(() => {
                            // // this.teamCarousel.resize()
                        }, 1755)
                    }, 1055)
                }
            },
            immediate: true,
        },
    },

    computed: {
        pageIsLoaded() {
            return this.contentIsLoaded && this.globalsIsLoaded
        },
        ...mapState(['contentIsLoaded', 'globalsIsLoaded']),
        ...mapGetters(['seo', 'content', 'globals']),
    },

    methods: {
    },
}
</script>

<style lang="scss" scoped>
.helper {
    position: absolute;
    top: 50%;
    right: 0;
    transform: translate(0, -50%);
    color: #fff;
    line-height: 1;
    padding: 0;
    margin: 0;
    padding-right: 55px;
    z-index: 5;
}
</style>
